import Badge from 'assets/icons/badge.svg';
import Resume from 'assets/icons/resume.svg';
import Chat from 'assets/icons/chat.svg';
import Support from 'assets/icons/support.svg';

export const cardsData = [
  {
    icon: Badge,
    title: 'Полное погружение',
    text: 'Ты работаешь в действующих командах и реальной среде — без симуляций и учебных сценариев',
  },
  {
    icon: Resume,
    title: 'Реальные задачи бизнеса',
    text: 'Ты решаешь реальные задачи компании с конкретными сроками и полной ответственностью за результат',
  },
  {
    icon: Chat,
    title: 'Регулярная обратная связь',
    text: 'Тебе прямо говорят, где ты уже на уровне руководителя, а где нужно усиливаться',
  },
  {
    icon: Support,
    title: 'Поддержка менторов',
    text: 'Рядом всегда есть опытные наставники, к которым можно прийти с вопросами и сложными задачами',
  },
];

export const bottomShadowSameStyles = {
  position: 'bottom',
  h: { mobile: '86px', tablet: '106px', laptop: '123px' },
  zIndex: '2',
};
